export default "__VITE_ASSET__Bu$h51fK__"